import { ServiceGroup, ServiceItem } from 'orderme-api-integration-client';
import { store } from '../../redux/store';
import { ViewProductEventData } from './omnisend.types';
import { apiKey, imagesUri } from '../../helpers/clientConfigs';
import { isMarketingCookiesAccepted } from '../../helpers/cookiesConsentStorage';
import { ITracker } from '../tracker';

export class OmnisendTracker implements ITracker {
  public identifyContact(): void {
    try {
      if (!this.canTrack()) {
        return;
      }

      if (store.getState().customerState.loginInfo?.email) {
        window.omnisend.identifyContact({
          email: store.getState().customerState.loginInfo.email,
          phone: store.getState().customerState.loginInfo.phone,
        });
      }
    } catch (error) {
      console.error('Tracker error identifying contact:', error);
    }
  }

  public trackPage(): void {
    try {
      if (this.canTrack()) {
        window.omnisend.push(['track', '$pageViewed']);
      }
    } catch (error) {
      console.error('Tracker error tracking page view:', error);
    }
  }

  public viewedProductsGroup(serviceGroup: ServiceGroup, productUrl: string): void {
    try {
      if (!this.canTrack()) {
        return;
      }

      const productId = serviceGroup.id;
      const title = serviceGroup.name;
      const imageUrl = `${imagesUri}/${serviceGroup.logoId}?orderme-api-key=${apiKey}`;

      const eventData: ViewProductEventData = {
        origin: 'api',
        eventVersion: 'v4',
        properties: {
          product: {
            id: productId,
            title: title,
            url: productUrl,
            imageUrl: imageUrl,
          },
        },
      };

      window.omnisend.push(['track', 'viewed product', eventData]);
    } catch (error) {
      console.error('Tracker error viewing products group:', error);
    }
  }

  public viewedProduct(serviceItem: ServiceItem, productUrl: string): void {
    try {
      if (!this.canTrack()) {
        return;
      }

      const productId = serviceItem.id;
      const title = serviceItem.name;
      const imageUrl = serviceItem.logoId ? `${imagesUri}/${serviceItem.logoId}?orderme-api-key=${apiKey}` : undefined;

      const eventData: ViewProductEventData = {
        origin: 'api',
        eventVersion: 'v4',
        properties: {
          product: {
            id: productId,
            title: title,
            url: productUrl,
            imageUrl: imageUrl,
          },
        },
      };

      window.omnisend.push(['track', 'viewed product', eventData]);
    } catch (error) {
      console.error('Tracker error viewing product:', error);
    }
  }

  public startedCheckout(): void {
    // Don't need to track
  }

  public canTrack(): boolean {
    if (!window.omnisend) {
      return false;
    }

    return isMarketingCookiesAccepted();
  }
}
